import React from 'react';
import { Link } from 'react-router-dom';

const VideoNavigation = ({ currentId }) => {
    const navItems = [
        {
            path: '/client/videos',
            label: 'Возможности',
            id: undefined
        },
        {
            path: '/client/videos/tech',
            label: 'Технологии',
            id: 'tech'
        },
        {
            path: '/client/videos/plugins',
            label: 'Плагины для расширенного мониторинга',
            id: 'plugins'
        }
    ];

    return (
        <nav className="videos-navigation">
            <ul className="space-y-2">
                {navItems.map((item, index) => (
                    <li key={index}>
                        <Link
                            to={item.path}
                            className={`block p-3 rounded-lg transition-colors ${
                                currentId === item.id 
                                    ? 'bg-blue-100 text-blue-700 font-semibold' 
                                    : 'hover:bg-gray-100 text-gray-700'
                            }`}
                        >
                            {item.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default VideoNavigation;